// 搜索历史相关的API接口
import { getApiClient } from '../services/api/index';
import type { EditSearchHistoryParams } from '../types/search';

// 搜索历史获取
export const getUserOperationHistorySearch = async (search_area: string) => {
  const client = await getApiClient();
  const response = await client.get<string[]>('/user_operation/history_search/', {
    search_area,
    history_length: 35,
  });
  return response.data;
};

// 增加/删除 搜索历史
export const postUserOperationHistorySearch = async (params: EditSearchHistoryParams) => {
  const client = await getApiClient();
  const response = await client.post<string[]>('/user_operation/history_search/', {
    ...params,
    history_length: 35,
  });
  return response.data;
};

export interface UploadBehaviorData {
  behavior: string;
  source?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  session_id: string;
  refer?: string;
  keyword_search?: string;
  country: string;
  platform: string;
  gclid?: string;
}

export const postUserOperationUserBehavior = async (data: UploadBehaviorData) => {
  const client = await getApiClient();
  const response = await client.post<unknown>('/user_operation/user_behavior/', data, {
    autoErrorHandle: false,
  });
  return response.data;
};
